// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const abomasnow: PokeData = {
  "id": 460,
  "name": "abomasnow",
  "height": 22,
  "weight": 1355,
  "base_experience": 173,
  "types": [
    PokeType.GRASS,
    PokeType.ICE
  ],
  "api_moves": [
    "ice-punch",
    "leer",
    "mist",
    "blizzard",
    "razor-leaf",
    "powder-snow",
    "icy-wind",
    "swagger",
    "ingrain",
    "grass-whistle",
    "sheer-cold",
    "energy-ball",
    "ice-shard",
    "wood-hammer",
    "icicle-crash",
    "leafage",
    "aurora-veil"
  ],
  "moves": [
    "ice-punch",
    "leer",
    "blizzard",
    "razor-leaf",
    "sheer-cold",
    "energy-ball",
    "ice-shard",
    "wood-hammer",
    "aurora-veil",
    "power-whip",
    "icicle-dagger",
    "bullet-seed",
    "solar-beam"
  ],
  "evolution_chain": {
    "id": 239,
    "item": null,
    "species": [
      {
        "name": "snover",
        "order": 478,
        "types": [
          PokeType.GRASS,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "abomasnow",
        "order": 479,
        "types": [
          PokeType.GRASS,
          PokeType.ICE
        ],
        "evolves_from_species_id": 459,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 143,
    "speed": 101,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
